import React, { useState, useEffect } from "react";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";

import { Typography, Container, Paper, Box } from "@mui/material";

import Loader from "../components/loader";
import CreditCardForm from "../components/signup";
import { stripeApiConfig } from "../config";
import useStripe from "../hooks/stripe";
import { componentStyles, gradients } from "../styles/themeStyles";

export const SignupForm = () => {
  const { getStripeIntent, saveStripeIntent } = useStripe();
  const stripePromise = loadStripe(stripeApiConfig.token);

  const navigate = useNavigate();

  const q = new URLSearchParams(window.location.search);
  const [secret, setSecret] = useState(q.get("setup_intent_client_secret"));
  const intent = q.get("setup_intent");

  useEffect(() => {
    if (intent) {
      saveStripeIntent(intent)
        .then(() => {
          navigate("/cluster/new");
        })
        .catch((err) => {
          console.error(err);
          // navigate('/signup', { replace: true });
        });
      return;
    }
    getStripeIntent()
      .then((i) => setSecret(i.clientSecret))
      .catch((e) => console.error("stripe intent get error", e));
  }, [intent, getStripeIntent, navigate, saveStripeIntent]);

  if (intent) {
    return (
      <Container maxWidth="md" sx={{ py: 4, px: { xs: 2, sm: 3, md: 4 } }}>
        <Paper elevation={0} sx={componentStyles.pageHeader}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 2,
              ...gradients.text.style,
            }}
          >
            Sign up
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Thank you for signing up. Redirecting you back to cluster creation
            shortly.
          </Typography>
        </Paper>
      </Container>
    );
  }

  if (!secret) {
    return <Loader text="Loading payment form" />;
  }

  return (
    <Container maxWidth="md" sx={{ py: 4, px: { xs: 2, sm: 3, md: 4 } }}>
      <Paper elevation={0} sx={componentStyles.pageHeader}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 2,
            ...gradients.text.style,
          }}
        >
          Sign up
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          In order to set up infrastructure and charge you for Microcumulus
          services, we need your payment information.
        </Typography>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography variant="body1" sx={{ mb: 3 }}>
          Please enter your details via the Stripe&trade; form below.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          None of this information is handled directly by Microcumulus, but is
          stored and managed by Stripe, where you will have access to manage
          payment details and subscriptions directly if you ever need to.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Important to note that your billing address will be used to calculate
          sales tax. If this is not desired, please contact us at
          support@microcumulus.com.
        </Typography>

        <Elements stripe={stripePromise} options={{ clientSecret: secret }}>
          <CreditCardForm clientSecret={secret} />
        </Elements>
      </Paper>
    </Container>
  );
};
